export default __webpack_public_path__ + "static/media/background_paper.30000f91.jpg";